<template>
  <div>
    <div
      class="page-header clear-filter"
      filter-color="black"
      style="min-height: 1080px !important;"
    >
      <div
        style="position:absolute; left:0px; top:0px; position: absolute; z-index: -2;
      background-image: url('/img/1st_sale/img_1st_sale.png');
        background-size: 100% 100%;
        background-position: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;"
      ></div>
      <div
        style="position:absolute; left:0px; top: 90px; position: absolute; z-index: 0;
      background-image: url('/img/1st_sale/frame_1st_sale.png');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        width: 100%;
        height: 969px;"
      >
        <div
          v-bind:style="{position: 'absolute', width: 'calc(50%)', height: '47px', 'top': '2px', 'left': '0px', 'background-color': tabs[0] ? 'white' : '#1d212a', 'cursor': 'pointer'}"
          @click="clickTab(0)"
        >
          <h5
            v-bind:style="{color: tabs[0] ? '#000000' : '#454b57', 'text-align': 'center', 'margin-top': '6px', 'font-size': '22px', 'font-weight': 600}"
          >{{$t('presale_tab_basic')}}</h5>
        </div>
        <div
          v-bind:style="{position: 'absolute', width: 'calc(50%)', height: '47px', 'top': '2px', 'right': '0px', 'background-color': tabs[1] ? 'white' : '#1d212a', 'cursor': 'pointer'}"
          @click="clickTab(1)"
        >
          <h5
            v-bind:style="{color: tabs[1] ? '#000000' : '#454b57', 'text-align': 'center', 'margin-top': '6px', 'font-size': '22px', 'font-weight': 600}"
          >{{$t('presale_tab_advanced')}}</h5>
        </div>
      </div>
      <div v-if="tabs[0]" style="position: absolute; left: 0px; top: 140px; width: 100%; height: 100%;">
        <div
          style="position:absolute; left:0px; top: 0px; z-index: 0;
        background-image: url('/img/1st_sale/bg_sale_1.png');
          background-size: 100% 100%;
          background-position: center center;
          background-repeat: no-repeat;
          width: 100%;
          height: 543px;"
        >
          <div
            style="position: absolute; top: 0px; left: 0px; width: 100%; height: 435px; padding: 20px 5px;"
          >
            <div
              v-for="product in products"
              v-bind:key="product.level"
              style="position: relative; width: 100%; height: 62px; background-color: white; border-radius: 5px; margin-bottom: 4px;"
            >
              <div
                style="position: absolute; left: 8px; top: 0px; width: 90px; height: 100%; color: black; font-size: 13px; font-weight: 900; text-align: center; padding-top: 12px;"
              >
                {{$t('Dev. Rank')}} {{product.level}}
                <br />
                {{product.price.toFixed(4)}}ETH
              </div>
              <div
                style="position: absolute; left: calc((100% - 100px) / 2 - 10px); top: 15px; width: 100px; height: 36px; color: white; font-size: 16px; font-weight: 600; text-align: center; background-color: #222222; padding-top: 4px;"
              >
              <input 
              v-model="landNum[product.level]"
              style="width: 100%; height: 30px; background-color: transparent; border: none; color: white; text-align: center;">
              </div>
              <div
                style="position: absolute; left: calc((100% - 100px) / 2 - 20px); top: 15px; width: 39px; height: 36px; background-image: url('/img/1st_sale/btn_minus.png'); background-size: 100% 100%; cursor: pointer;"
                @click="minusBasicSelect(product.level)"
              ></div>
              <div
                style="position: absolute; right: calc((100% - 100px) / 2); top: 15px; width: 39px; height: 36px; background-image: url('/img/1st_sale/btn_plus.png'); background-size: 100% 100%; cursor: pointer;"
                @click="plusBasicSelect(product.level)"
              ></div>
              <div v-if="product.remain > 0"
                style="position: absolute; right: 5px; top: 2px; width: 100px; height: 100%; color: #888888; font-size: 12px; font-weight: 600; text-align: center; padding-top: 4px; text-align: left;"
              >
                {{$t('remain')}}: <span style="color: #0000aa;">{{product.remain | comma}}</span><br/>
                {{$t('sales_count')}}: <span style="color: #0000aa;">{{product.total | comma}}</span><br/>
                {{$t('in_confirm')}}: <span style="color: #aa0000;">{{product.inTrx | comma}}</span>
              </div>
              <div v-else
                style="position: absolute; right: 5px; top: 5px; width: 100px; height: 100%; color: #888888; font-size: 12px; font-weight: 600; text-align: center; padding-top: 4px; text-align: left;"
              >
                {{$t('remain')}}: <span style="font-size: 10px;  color: #aa0000;">{{$t('SOLD OUT')}}</span><br/>
                {{$t('sales_count')}}: <span style="color: #0000aa;">{{product.total | comma}}</span>
              </div>
            </div>
          </div>
          <div
            style="position: absolute; top: 435px; left: 0px; width: 100%; height: 108px; text-align: center; padding: 10px;"
          >
            <div
              v-if="account == null"
              style="width: 270px; height: 68px; background-image: url('/img/btn_270.png'); margin: auto; text-align: center; color: #fff568; font-size: 20px; font-weight: 600; padding-top: 18px; cursor: pointer;"
              @click="openWallet()"
            >{{$t('connect_wallet')}}</div>
            <div v-if="account != null" style="position: absolute; width: 100%; height: 100%;">
              <div
                style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px; color: white; text-align: left; padding: 5px 5px; font-size: 12px;"
              >
                <span style="color: #cccccc;">{{$t('wallet_address')}} :</span>
                {{account.address}}
                <br />
                <span style="color: #cccccc;">{{$t('wallet_balance')}} :</span>
                {{(account.balance)}} {{selectedToken.token_symbol}}
              </div>
              <div
                style="position: absolute; right: -20px; top: 40px; width: 180px; height: 48px; margin: auto; text-align: center; font-size: 14px; font-weight: 600; padding-top: 10px; text-decoration: underline; cursor: pointer; color: #999999;"
                @click="disconnect()"
              >{{$t('disconnect_wallet')}}</div>
            </div>
          </div>
        </div>
        <div
          style="position:absolute; left:0; top: 540px; z-index: 0;
        background-image: url('/img/1st_sale/bg_sale_2.png');
          background-size: 100% 100%;
          background-position: center center;
          background-repeat: no-repeat;
          width: 100%;
          height: 209px;"
        >
          <div
            style="position: absolute; left: 0px; top: 0px; padding: 10px; width: 100%; height: 42px;"
          >
            <div
              v-for="(cart, index) in cart.byLevels"
              v-bind:key="index"
              v-bind:style="{position: 'absolute', left: `calc(20% * ${index})`, width: 'calc(18%)', height: '42px', 'background-color': `white`, 'border-radius': '10px', 'text-align': 'center', 'padding-top': '0px'}"
            >
              <span
                style="color: black; font-size: 12px; font-weight: 900;"
              >{{$t('Dev. Rank')}} {{cart.level}}</span>
              <span style="color: black; font-size: 10px; font-weight: 300;">X{{cart.num}}</span>
            </div>
          </div>
          <div
            style="position: absolute; width: 70%; height: 40px; left: 0px; top: 65px; background-image: url('/img/1st_sale/btn_sort_1.png'); background-size: 100% 100%;"
          >
            <div
              style="position: absolute; width: calc(35%); height: 100%; left: 0px; top: 0px; cursor: pointer;"
            >
              <select
                v-model="token"
                @change="onTokenChange($event)"
                style="width: 100%; height: 100%; background: transparent; color: #00ffff; padding-left: 10px;"
              >
                <option
                  v-for="(item, index) in tokens"
                  v-bind:key="index"
                  v-bind:value="item.token_symbol"
                  v-bind:style="{color: index < 2 ? 'blue' : 'black'}"
                >{{ item.token_symbol }}</option>
              </select>
            </div>
            <div
              style="position: absolute; width: calc(65%); height: 100%; left: calc(35%); text-align: right; padding: 5px; color: white; font-size: 16px;"
            >{{(amount.price / selectedToken.rate_eth_now).toFixed(4)}}</div>
          </div>
          <div
            v-if="selectedToken.token_symbol != 'ETH'"
            style="position: absolute; width: calc(70%); height: 40px; color: #00ffff; top: 110px; left: 5px; text-align: left;"
          >1 {{selectedToken.token_symbol}} = {{selectedToken.rate_eth_now.toFixed(6)}} ETH</div>
          <div
            v-else
            style="position: absolute; width: calc(70%); height: 40px; color: #00ffff; top: 110px; left: 5px; text-align: left;"
          ></div>"
          <div
            style="position: absolute; width: 25%; height: 80px; top: 65px; right: calc(2%); background-image: url('/img/1st_sale/btn_300_buy.png'); background-size: 100% 100%; color: white; font-size: 26px; text-align: center; padding-top: 15px; text-shadow: 2px 2px #000000; cursor: pointer;"
            @click="buy(1)"
          >{{$t('BUY')}}</div>
        </div>
      </div>
      <div v-if="tabs[1]" style="position: absolute; left: 0px; top: 140px; width: 100%; height: 100%;">
        <n-button
          type="primary"
          style="position: absolute; top: 0px; width: 96%; left: 2%; text-align: center; border-radius: 5px;"
          ref="header0"
          @click="toggle(0);"
        >
          {{$t('Select Zone')}} [{{currentZone}}]
          <div style="position: absolute; left: 220px; top: 12px;">
            <i
              v-if="!toggles[0]"
              class="now-ui-icons arrows-1_minimal-up"
              style="position: relative; left: 90px;"
            ></i>
            <i
              v-if="toggles[0]"
              class="now-ui-icons arrows-1_minimal-down"
              style="position: relative; left: 90px;"
            ></i>
          </div>
        </n-button>
        <div
          ref="content0"
          style="position: absolute; left: 0px; display: block; top: 55px; width: 100%; height: 342px;"
        >
          <div
            class="minimap-area3"
            v-bind:style="{position: 'absolute', width: `${minimapSize + 12}px`, height: `${minimapSize + 12}px`, left: 'calc(2% + 2px)'}"
          >
            <div class="minimap-scroll-stage3">
              <grid-layer
                :viewport="viewport"
                :visible="showGridChecked"
                v-if="renderGrid"
                v-bind:onSale="true"
                v-bind:columnCount="8"
                v-bind:rowCount="8"
                v-bind:tileWidth="minimapTileSize"
                v-bind:tileHeight="minimapTileSize"
                v-bind:mapType="0"
              ></grid-layer>
            </div>
            <div class="zoneinfo-area">
              <p style="font-size: 15px; color: black; font-weight: 900; height: 12px; text-align: center;">{{$t('remain')}}/{{$t('sales_count')}}/{{$t('in_confirm')}}</p>
              <div style="position: absolute; top: 28px; left: 10px; width: calc(100% - 20px); height: calc(100% - 28px); display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                <div v-for="(product, index) in products" v-bind:key="index" style="position: relative; margin-top: 8px; font-size: 14px; color: black; font-weight: 600; width: 135px; height: 27px;">
                  <div>Lv.{{product.level}}</div> 
                  <div v-if="product.remain > 0" style="position: absolute; left: 40px; top: 0px; color: #0000aa; font-size: 13px; font-weight: 900; width: 100px; text-align: right;">{{product.remain | comma}}/{{product.total | comma}}<span style="color: #aa0000;">/{{product.inTrx | comma}}</span></div>
                  <div v-else style="position: absolute; left: 40px; top: -3px; color: #0000aa; font-size: 16px; font-weight: 900; width: 100px; text-align: right;"><span style="color: #aa0000;">0/</span>{{product.total | comma}}</div>
                </div>
              </div>          
            </div>
          </div>
        </div>
        <n-button
          type="info"
          v-bind:style="{'text-align': 'center', position: 'absolute', left: '0px', top: `${55 + 355 * (toggles[0] ? 1 : 0)}px `, width: '96%', left: '2%', 'border-radius': '5px'}"
          ref="header1"
          @click="toggle(1);"
        >
          {{$t('Select Land')}} [{{selectedLandId == 0 ? '-' : `#${selectedLandId}`}}]
          <div style="position: absolute; left: 220px; top: 12px;">
            <i
              v-if="!toggles[1]"
              class="now-ui-icons arrows-1_minimal-up"
              style="position: relative; left: 90px;"
            ></i>
            <i
              v-if="toggles[1]"
              class="now-ui-icons arrows-1_minimal-down"
              style="position: relative; left: 90px;"
            ></i>
          </div>
        </n-button>
        <div ref="content1" style="position: absolute; left: 0px; display: none; top: 120px; width: 100%; height: calc(40vh);">
          <div
            style="background-image: url('/img/frame_zone_m.png'); background-size: 100% 100%; position: absolute; left: 0px; top: 0px; width: 100%; height: 100%;"
          ></div>
          <div
            ref="mapscroll"
            v-dragscroll
            style="position: absolute; overflow: auto; left: 6px; top: 6px; height: calc(40vh - 12px); width: calc(100% - 12px);"
            v-on:dragscrollmove="onScrollMove($event.detail)"
          >
            <div class="map-area">
              <div class="map-scroll-stage">
                <grid-layer
                  :viewport="viewport"
                  :visible="showGridChecked"
                  v-bind:visibleDevRank="visibleDevRank"
                  v-bind:onSale="true"
                  v-if="renderGrid"
                  v-bind:mapType="1"
                  v-bind:selectedId="selectedId"
                  v-bind:minimapScroll="minimapScroll"
                  v-bind:tileWidth=22
                  v-bind:tileHeight=22
                ></grid-layer>
              </div>
            </div>
          </div>
        </div>
        <div class="cart-area2" v-bind:style="{top: toggles[1] ? 'calc(60vh)' : '470px'}">
          <div
            style="position: absolute; top: 10px; left: 10px; width: calc(100% - 20px); height: 30px; text-align: center; color: white; font-size: 16px; font-weight: 600;"
          >
            {{$t('CART')}}
          </div>
          <div
            class="scrollbox"
            style="position: absolute; top: 40px; left: 10px; width: calc(100% - 20px); height: 144px; overflow-y: auto;"
          >
            <div
              style="position: relative; width: 100%; height: 32px; margin-top: 5px;"
              v-for="land in this.cart.byLands"
              v-bind:key="land.landId"
            >
              <div
                style="width: 267px; height: 32px; background-image: url('/img/1st_sale/bg_land_list_2.png'); position: absolute; left: 10px; top: 0px;"
              >
                <h5
                  style="font-size: 16px; color: black; font-weight: 900; width: 90px; position: absolute; left: 0px; top: 4px; text-align: center;"
                >#{{land.landId}}</h5>
                <h5
                  style="font-size: 16px; color: black; font-weight: 900; width: 90px; position: absolute; left: 90px; top: 4px; text-align: center;"
                >Lv. {{land.level}}</h5>
                <h5
                  style="font-size: 12px; color: black; font-weight: 600; width: 83px; position: absolute; left: 180px; top: 7px; text-align: right;"
                >{{land.price.toFixed(4)}}ETH</h5>
              </div>
              <div
                @click="clearFromCart(land.landId)"
                style="width: 28px; height: 28px; background-image: url('/img/1st_sale/btn_x.png');  position: absolute; left: 287px; top: 3px; cursor: pointer;"
              ></div>
            </div>
          </div>
          <div
            style="position: absolute; left: 10px; top: 185px; padding: 10px 20px; width: 795px; height: 49px;"
          >
            <div
              v-for="(cart, index) in cart.byLevels"
              v-bind:key="index"
              v-bind:style="{position: 'absolute', left: `${(index % 3) * 108 + 5}px`, top: `${8 + Math.floor(index / 3) * 30}px`, width: '100px', height: '28px', 'background-image': `url('/img/1st_sale/bg_rank_2.png')`, 'background-size': '100% 100%', 'text-align': 'center', 'padding-top': '3px'}"
            >
              <span
                style="color: black; font-size: 13px; font-weight: 600;"
              >{{$t('Dev. Rank')}} {{cart.level}}</span>
              <span style="color: black; font-size: 11px; font-weight: 300;">X{{cart.num}}</span>
            </div>
          </div>
          <div
            style="position: absolute; width: 298px; height: 41px; left: 24px; top: 260px; background-image: url('/img/1st_sale/btn_sort_2.png');"
          >
            <div
              style="position: absolute; width: 140px; height: 100%; left: 0px; top: 0px; cursor: pointer;"
            >
              <select
                v-model="token"
                @change="onTokenChange($event)"
                style="width: 100%; height: 100%; background: transparent; color: #00ffff; padding-left: 30px;"
              >
                <option
                  v-for="(item, index) in tokens"
                  v-bind:key="index"
                  v-bind:value="item.token_symbol"
                  v-bind:style="{color: index < 2 ? 'blue' : 'black'}"
                >{{ item.token_symbol }}</option>
              </select>
            </div>
            <div
              style="position: absolute; width: 195px; height: 100%; left: 100px; text-align: right; padding: 7px; color: white; font-size: 16px;"
            >{{(amount.price / selectedToken.rate_eth_now).toFixed(4)}}</div>
          </div>
          <div
            v-if="selectedToken.token_symbol != 'ETH'"
            style="position: absolute; width: 308px; height: 40px; color: #00ffff; top: 300px; left: 20px; text-align: left; overflow-wrap: break-word; font-size: 13px;"
          >1 {{selectedToken.token_symbol}} = {{selectedToken.rate_eth_now.toFixed(6)}} ETH</div>
          <div
            v-else
            style="position: absolute; width: 308px; height: 40px; color: #00ffff; top: 300px; left: 20px; text-align: left; overflow-wrap: break-word; font-size: 13px;"
          ></div>"
          <div
            style="position: absolute; width: 307px; height: 60px; top: 340px; left: calc((100% - 307px)/2); background-image: url('/img/1st_sale/btn_300_buy.png'); background-size: 100% 100%; color: white; font-size: 26px; text-align: center; padding-top: 10px; text-shadow: 2px 2px #000000; cursor: pointer;"
            @click="buy(2)"
          >{{$t('BUY')}}</div>
        </div>


        <!-- <div class="map-area2">
          <div class="map-title3">
            <h6 class="card-title mb-4">Zone #{{currentZone}}</h6>
          </div>
          <div class="map-title4">
            <h6 class="card-title mb-4" style="color: white;">{{$t('Dev. Rank')}}</h6>
          </div>
          <div class="map-scroll-stage2">
            <grid-layer
              :viewport="viewport"
              :visible="showGridChecked"
              v-bind:visibleDevRank="visibleDevRank"
              v-bind:onSale="true"
              v-bind:tileWidth="22"
              v-bind:tileHeight="22"
              v-if="renderGrid"
              v-bind:mapType="1"
            ></grid-layer>
          </div>
        </div>
        <div class="minimap-area2">
          <div class="minimap-scroll-stage2">
            <grid-layer
              :viewport="viewport"
              :visible="showGridChecked"
              v-if="renderGrid"
              v-bind:columnCount="8"
              v-bind:rowCount="8"
              v-bind:tileWidth="37.5"
              v-bind:tileHeight="37.5"
              v-bind:mapType="0"
            ></grid-layer>
          </div>
        </div>
        <div class="zoneinfo-area">
          <p style="font-size: 16px; color: black; font-weight: 900; padding-left: 10px; padding-top: 3px; height: 12px;">ZONE #{{currentZone}}</p>
          <p v-for="(remainLand, index) in remainLands" v-bind:key="index" style="font-size: 14px; color: black; font-weight: 600; height: 3px; padding-left: 10px; padding-top: 3px;">
            {{$t('Dev. Rank')}} {{remainLand.landLevel}} : {{remainLand.remain | comma}}
          </p>
        </div>
        <div class="gamemap-area2" v-if="selectedLandId != 0">
          <div class="gamemap-title2">
            <h6 class="card-title mb-4">{{$t('Game Field')}}</h6>
          </div>
          <div class="gamemap-scroll-area2">
            <div v-for="object in trees" v-bind:key="object._id">
              <div
                v-bind:style="{position: 'absolute', left:`${object.x}px`, top:`${object.y}px`, width:'37.5px', height:'37.5px'}"
              >
                <img v-bind:src="`/img/Tiles/fo_${object.code}.png`" width="100%" />
              </div>
            </div>
            <div v-for="object in objects" v-bind:key="object._id">
              <div
                v-bind:style="{position: 'absolute', left:`${object.x}px`, top:`${object.y}px`, width:'37.5px', height:'37.5px'}"
              >
                <img
                  v-if="object.display != null"
                  v-bind:src="`/img/object_${object.display}.png`"
                  width="100%"
                />
                <h5
                  v-if="object.display != null"
                  style="width:100%; height: 100%; text-align: center; margin-top: -13px; color: white; font-size: 0.7em;"
                >Lv.{{object.level}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="land-info-area2" v-if="selectedLandId != 0">
          <div class="land-info-title2">
            <h6 class="card-title mb-4">{{$t('Land')}} #{{landInfo.landId}}</h6>
          </div>
          <table style="width: 100%; margin-top: 20px;">
            <tr style="height: 32px;">
              <td style="width: 30%;">
                <h6 class="card-title2">{{$t('Dev. Rank')}}</h6>
              </td>
              <td style="width: 70%;">
                <h6 class="card-title3" style="font-size: 18px; font-weight: 900; color: #0000cc;">{{landInfo.attributes.devRank}}</h6>
              </td>
            </tr>
            <tr style="height: 32px;">
              <td style="width: 30%;">
                <h6 class="card-title2">{{$t('sale_status')}}</h6>
              </td>
              <td style="width: 70%;">
                <h6
                  v-if="landInfo.sale.reserved == null"
                  class="card-title3" style="font-size: 18px; font-weight: 900; color: #0000cc;"
                >{{$t(`sale_${landInfo.sale.status}`)}}</h6>
                <h6 v-else class="card-title3" style="font-size: 16px; font-weight: 600; color: #999999;">{{$t('sale_reserved', [landInfo.sale.reserved])}}</h6>
              </td>
            </tr>
            <tr style="height: 40px;">
              <td style="width: 30%;">
                <h6 class="card-title2">{{$t('Owner')}}</h6>
              </td>
              <td style="width: 70%;">
                <h6 class="card-title3" v-if="landInfo.owner != null">
                  <a
                    v-bind:href="getEtherScanUrl(landInfo.owner.address)"
                    target="_blank"
                  >{{landInfo.owner.address}}</a>
                </h6>
                <h6 class="card-title3" v-if="landInfo.owner == null">-</h6>
              </td>
            </tr>
            <tr style="height: 32px;">
              <td style="width: 30%;">
                <h6 class="card-title2">{{$t('Price')}}</h6>
              </td>
              <td style="width: 70%;">
                <h6 v-if="landInfo.sale.status == 1" class="card-title3">-</h6>
                <h6 v-else class="card-title3" style="font-size: 18px; font-weight: 900; color: #0000cc;">{{landInfo.sale.price}}</h6>
              </td>
            </tr>
          </table>
          <div
            style="position: absolute; top: 155px; left: 0px; width: 100%; height: 68px; text-align: center;"
          >
            <div
              v-if="landInfo.sale.status == 2"
              @click="addToCart(landInfo)"
              style="width: 180px; height: 48px; background-image: url('/img/btn_180.png'); font-size: 1.2em;
                  font-weight: 400;
                  text-align: center;
                  color: #fff568; padding-top: 10px;"
              class="btn"
            >{{$t('add to cart')}}</div>
            <div v-if="account == null">
              <div
                @click="openWallet()"
                style="position: absolute; top: 80px; left: calc((100% - 270px)/2); width: 270px; height: 68px; background-image: url('/img/btn_270.png'); font-size: 1.2em;
                  font-weight: 400;
                  text-align: center;
                  color: #fff568; padding-top: 20px;"
                class="btn"
              >{{$t('connect_wallet')}}</div>
            </div>
            <div v-else>
              <div
                style="position: absolute; width: 350px; height: 100%; left: 0px; top: 55px; color: white; text-align: left; padding: 10px 10px; font-size: 13px; overflow-wrap: break-word;"
              >
                <span style="color: #cccccc;">{{$t('wallet_address')}} :</span>
                {{account.address}}
                <br />
                <span style="color: #cccccc;">{{$t('wallet_balance')}} :</span>
                {{(account.balance)}} {{selectedToken.token_symbol}}
              </div>
              <div
                style="position: absolute; left: calc((100% - 180px) / 2); top: 130px; width: 180px; height: 48px; margin: auto; text-align: center; font-size: 18px; font-weight: 600; padding-top: 10px; text-decoration: underline; cursor: pointer; color: #999999;"
                @click="disconnect()"
              >{{$t('disconnect_wallet')}}</div>
            </div>
          </div>
        </div>
        -->
      </div>
    </div>

    <div
      style="position: fixed; left: 0px; top: 0px; width: 100%; height: 100%; background-color: #00000099; cursor: pointer; z-index: 900;"
      v-if="popups.buyResult"
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="popups.buyResult"
      style="position: fixed; top: calc((100% - 440px) / 2); left: 5%; padding-top: 32px; text-align: center; width: calc(90%); height: 340px; background-image: url('/img/1st_sale/pop_wallet.png'); background-size: 100% 100%; z-index: 10000;"
    >
      <div
        style="position: absolute; top: 28px; right: 30px; width: 40px; height: 40px; cursor: pointer;"
        @click="closePopup('buyResult')"
      >
        <img src="/img/event/btn_close.png" />
      </div>
      <h5 style="color: white; font-size: 24px; font-weight: 900;">{{$t('title_buy_result')}}</h5>
      <div
        v-if="trading.status == 'trading'"
        style="position: absolute; top: 90px; left: calc(5%); width: 90%; height: 240px; text-align: center; font-size: 16px; font-weight: 300; color: black; padding-top: 30px; overflow-wrap: break-word;"
      >
        <div v-if="trading.txHash == ''" v-html="$t('info_buying_approval')"></div>
        <div v-if="trading.txHash != ''" v-html="$t('info_in_buying')"></div>
        <div
          @click="goToPresaleHistory()"
          v-if="trading.txHash != ''"
          style="text-decoration: underline; color: #0000ff; cursor: pointer;"
        >{{$t('go_to_presalehistory')}}</div>
        <span v-if="trading.txHash != ''" style="font-size: 14px;">
          {{trading.txHash}}
          <a
            v-bind:href="getEtherScanUrl(trading.txHash)"
            target="_blank"
          >[etherscan]</a>
        </span>
      </div>
      <div
        v-if="trading.status == 'trading_kyber'"
        style="position: absolute; top: 90px; left: calc(5%); width: 90%; height: 240px; text-align: center; font-size: 16px; font-weight: 300; color: black; padding-top: 30px; overflow-wrap: break-word;"
      >
        <div v-html="$t('info_waiting_kyber')"></div>
      </div>
      <div
        v-if="trading.status == 'completed'"
        style="position: absolute; top: 120px; left: calc(5%); width: 90%; height: 240px; text-align: center; font-size: 18px; font-weight: 600; color: black; padding-top: 0px; overflow-wrap: break-word;"
      >
        {{$t('info_success_buy')}}
        <br />
        <br />
        <span style="font-size: 14px;">
          {{trading.txHash}}
          <a
            v-bind:href="getEtherScanUrl(trading.txHash)"
            target="_blank"
          >[etherscan]</a>
        </span>
        <br />
        <div
          @click="goToMyLand()"
          style="background-image: url('/img/btn_180.png'); position: absolute; left: calc((100% - 180px)/2); bottom: 60px; background-size: 100% 100%; width: 180px; height: 48px; font-size: 18px; color: #fff568; font-weight: 600; padding-top: 10px; cursor: pointer;"
        >{{$t('go_myland')}}</div>
      </div>
      <div
        v-if="trading.status == 'fail_duplicated'"
        style="position: absolute; top: 120px; left: calc(5%); width: 90%; height: 240px; text-align: center; font-size: 18px; font-weight: 300; color: black; padding-top: 30px; overflow-wrap: break-word;"
      >{{$t('info_fail_buy_duplicated')}}</div>
      <div
        v-if="trading.status == 'fail_buy_insufficient_balance'"
        style="position: absolute; top: 120px; left: calc(5%); width: 90%; height: 240px; text-align: center; font-size: 18px; font-weight: 300; color: black; padding-top: 30px; overflow-wrap: break-word;"
      >{{$t('info_fail_buy_insufficient_balance')}}</div>
      <div
        v-if="trading.status == 'fail_cancel'"
        style="position: absolute; top: 120px; left: calc(5%); width: 90%; height: 240px; text-align: center; font-size: 18px; font-weight: 300; color: black; padding-top: 30px; overflow-wrap: break-word;"
      >{{$t('info_fail_cancel')}}</div>
      <div
        v-if="trading.status == 'fail_abnormal'"
        style="position: absolute; top: 120px; left: calc(5%); width: 90%; height: 240px; text-align: center; font-size: 18px; font-weight: 300; color: black; padding-top: 30px; overflow-wrap: break-word;"
      >{{$t('info_fail_abnormal')}}</div>
    </div>
  </div>
</template>
<script>
import config from "../config.js";
import axios from "axios";
import Web3 from "web3";
import Torus from "@toruslabs/torus-embed";
//import MapLayer from '../components/partials/MapLayer.vue';
import GridLayer from "../components/partials/GridLayer.vue";
import { Button } from "@/components";
import VueScreenSize from "vue-screen-size";
import { dragscroll } from "vue-dragscroll";
import ga from "../ga";

import {
  ERC20_ABI,
  refreshAccountBalance,
  web3,
  ETH,
  WEI,
  contract,
  connectWallet,
  disconnectWallet
} from "../utils/wallet";

const HIDE_GRID_WHEN_SCROLLING = true;

function isNumeric(num){
  return isNaN(num) ? false : true;
}

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    [Button.name]: Button,
    //MapLayer,
    GridLayer
  },
  directives: {
    dragscroll: dragscroll
  },
  mixins: [VueScreenSize.VueScreenSizeMixin],
  methods: {
    onScrollMove: function() {
      if (this.$refs.mapscroll == null) {
        this.minimapScroll = [0, 0, 0, 0];
      } else {
        this.minimapScroll = [
          (this.$refs.mapscroll.scrollLeft / 704) * 128,
          (this.$refs.mapscroll.scrollTop / 704) * 128,
          (this.$refs.mapscroll.clientWidth / 704) * 128,
          (this.$refs.mapscroll.clientHeight / 704) * 128
        ];
      }
    },
    toggle: function(content) {
      for (let i = 0; i < this.toggles.length; ++i) {
        if (i == content) {
          this.toggles[i] = true;
          this.$refs[`content${i}`].style.display = 'block';
        } else {
          this.toggles[i] = false;
          this.$refs[`content${i}`].style.display = 'none';
        }
      }
      this.onScrollMove();
    },
    goToPresaleHistory: function() {
      this.$router.push("/account/2");
    },
    goToMyLand: function() {
      this.$router.push("/account");
    },
    getEtherScanUrl: function(txHash) {
      return `${config.etherscan.tx}/${txHash}`;
    },
    clickTab: async function(tabIdx) {
      if (this.tabs[tabIdx]) {
        return;
      }
      for (let i = 0; i < this.tabs.length; ++i) {
        if (i == tabIdx) {
          this.$set(this.tabs, i, true);
        } else {
          this.$set(this.tabs, i, false);
        }
      }
      this.$store.commit("clearSelectedLands");
      this.clearAllCart();
      if (this.timerId != null) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
      if (tabIdx == 0) {
        await this.loadLandSaleInfo();
        this.timerId = setInterval(async () => {
          await this.loadLandSaleInfo();
        }, 10 * 1000);
      } else {
        for (let i = 0; i < this.toggles.length; ++i) {
          if (i == 0) {            
            this.toggles[i] = true;
          } else {
            this.toggles[i] = false;
          }
        }

        await this.loadLandSaleInfo(this.currentZone);
        this.timerId = setInterval(async () => {
          await this.loadLandSaleInfo(this.currentZone);
        }, 10 * 1000);
      }
    },
    loadLandSaleInfo: async function(zoneId) {
      let round = "pre2";
      let ret = await axios.post(`${config.api.nft_url}/presale/lands`, {
        round: round,
        zoneId: zoneId
      });
      let isStarted = ret.data.isStarted;
      this.$store.commit('setPresaleStarted', isStarted);

      if (this.tabs[0]) {
        this.products = ret.data.landSale.sale;
        this.basic.period = [
          ret.data.landSale.startDate,
          ret.data.landSale.endDate
        ];
      }
      this.remainLands = ret.data.remainLands;
    },
    getBasicSelected(level) {
      if (this.basic.selected["level_" + level] == null) {
        return 0;
      }
      let select = this.basic.selected["level_" + level];
      for (let i = 0; i < this.products.length; ++i) {
        if (this.products[i].level == level) {
          if (select > this.products[i].remain) {
            select = this.products[i].remain;
            this.basic.selected["level_" + level] = select;
            break;
          }
        }
      }
      return select;
    },
    arrangeBasicCart() {
      let byLevels = [];
      for (let i = 10; i >= 1; --i) {
        if (
          this.basic.selected["level_" + i] != null &&
          this.basic.selected["level_" + i] != 0
        ) {
          byLevels.push({ level: i, num: this.basic.selected["level_" + i] });
        }
      }
      this.cart.byLevels = byLevels;
      this.computePrice();
    },
    arrangeAdvancedCart() {
      let byLevels = [];
      for (let i = 10; i >= 1; --i) {
        let amount = 0;
        for (let j = 0; j < this.cart.byLands.length; ++j) {
          if (this.cart.byLands[j].level == i) {
            ++amount;
          }
        }
        if (amount > 0) {
          byLevels.push({ level: i, num: amount });
        }
      }
      this.cart.byLevels = byLevels;
      this.computePrice();
    },
    plusBasicSelect(level) {
      this.$set(this.landNum, level, this.landNum[level] + 1);
      // let select = this.getBasicSelected(level);
      // if (level == 6 && select >= 4) {
      //   return alert(this.$t("alert_6lv_limit"));
      // }
      // ++select;
      // for (let i = 0; i < this.products.length; ++i) {
      //   if (this.products[i].level == level) {
      //     if (select > this.products[i].remain) {
      //       select = this.products[i].remain;
      //     }
      //     this.$set(this.basic.selected, "level_" + level, select);
      //     break;
      //   }
      // }
      // this.arrangeBasicCart();
    },
    minusBasicSelect(level) {
      if (this.landNum[level] <= 0) {
        this.$set(this.landNum, level, 0);
        return;
      }
      this.$set(this.landNum, level, this.landNum[level] - 1);
      // let select = this.getBasicSelected(level);
      // if (select < 1) {
      //   select = 0;
      // } else {
      //   --select;
      // }
      // if (select <= 0) {
      //   this.basic.selected["level_" + level] = null;
      // }
      // for (let i = 0; i < this.products.length; ++i) {
      //   if (this.products[i].level == level) {
      //     if (select > this.products[i].remain) {
      //       select = this.products[i].remain;
      //     }
      //     this.$set(this.basic.selected, "level_" + level, select);
      //     break;
      //   }
      // }
      // this.arrangeBasicCart();
    },
    isSoldOut(landInfo) {
      for (let i = 0; i < this.products.length; ++i) {
        if (this.products[i].level == landInfo.attributes.devRank) {
          return this.products[i].remain == 0;
        }
      }
      return true;
    },
    clearAllCart() {
      this.$store.commit('clearSelectedLands');
      this.basic.selected = {};
      this.cart.byLands = [];
      this.cart.byLevels = [];
      this.arrangeBasicCart();
      this.arrangeAdvancedCart();
    },
    updateCart() {
      this.arrangeAdvancedCart();
    },
    clearFromCart(landId) {
      // for (let i = 0; i < this.cart.byLands.length; ++i) {
      //   if (this.cart.byLands[i].landId == landId) {
      //     this.cart.byLands.splice(i, 1);
      //     break;
      //   }
      // }
      // this.arrangeAdvancedCart();
      this.$store.commit("clearSelectedLand", { landId: landId });
    },
    openPopup(pop) {
      this.popups[pop] = true;
    },
    openWallet() {
      this.$store.commit(`openModal`, "wallet");
    },
    closePopup(pop) {
      this.popups[pop] = false;
    },
    closeAllPopup() {
      //this.closePopup("wallet");
    },
    // connect: async function(type) {
    //   var balance = 0;
    //   let account = connectWallet(this.$store, type);
    //   this.closePopup("wallet");
    // },
    disconnect: async function() {
      disconnectWallet(this.$store);
    },
    onTokenChange: async function() {
      if (this.tokenMap[this.token] == null) {
        return;
      }
      this.$store.commit("setToken", this.tokenMap[this.token]);
      await refreshAccountBalance(this.$store);
      this.computePrice();
    },
    computePrice: function() {
      this.amount.total = 0;
      this.amount.price = 0;
      for (var item of this.cart.byLevels) {
        for (let i = 0; i < this.products.length; ++i) {
          if (this.products[i].level == item.level) {
            this.amount.total += item.num;
            this.amount.price += item.num * Number(this.products[i].price);
            break;
          }
        }
      }
      this.amount.price = Math.round(this.amount.price * 10000) / 10000;
    },
    send: async function(data, value, callback) {
      var gasPrice = await web3.eth.getGasPrice();

      const param = {
        to: contract.options.address,
        from: this.account.address,
        value: WEI(value), // Only required to send ether to the recipient from the initiating external account.
        data: data
      };
      var estimateGas = await web3.eth.estimateGas(param);
      console.log(estimateGas);
      console.log(gasPrice);
      return new Promise((resolve, reject) => {
        console.log("param - ", param);
        try {
          web3.eth
            .sendTransaction(param)
            .on("transactionHash", async txHash => {
              console.log("transactionHash");
              console.log(txHash);
              ga.gaEvent('event', 'buySuccess', {
              });
              this.trading.txHash = txHash;
              let parameters = JSON.parse(localStorage.parameters);
              let device = "";
              if (this.$device.mobile) {
                device = "mobile/";
                if (this.$device.android || this.$device.androidPhone) {
                  device += "android";
                } else {
                  device += "ios";
                }
              } else {
                device = "pc";
              }
              let wallet = '';
              if (window.imToken != null) {
                wallet = 'imtoken';
              }
              else if (window.TPJSBrigeClient != null) {
                wallet = 'tokenpocket';
              }
              else if (window.MyKey != null) {
                wallet = 'mykey';
              }
              else if (window.Trust != null) {
                wallet = 'trust';
              }
              var ret = await axios.post(
                `${config.api.nft_url}/presale/transaction`,
                {
                  txHash: txHash,
                  sender: web3.eth.currentProvider.selectedAddress,
                  landIds: this.landIds,
                  utm_source: parameters.utm_source,
                  utm_medium: parameters.utm_medium,
                  ref: parameters.ref,
                  device: device,
                  language: navigator.language,
                  wallet: wallet
                }
              );
            })
            .on("receipt", async receipt => {
              console.log("receipt");
              resolve({ result: true, data: receipt });
            })
            .on("error", error => {
              console.log("error");
              console.log(error);
              ga.gaEvent('event', 'buyFail', {
              });
              if (error != null && error.code == 4001) {
                this.trading.status = "fail_cancel";
              }    
            });
          // console.log(result);
          // return {result: true, data: result};
        } catch (e) {
          ga.gaEvent('event', 'buyFail', {
          });
          // return {result: false, data: e};
          reject();
        }
      });
    },
    sendTo: async function(to, data, value, callback) {
      var gasPrice = await web3.eth.getGasPrice();

      const param = {
        to: to,
        from: this.account.address,
        value: WEI(value), // Only required to send ether to the recipient from the initiating external account.
        data: data
      };
      var estimateGas = await web3.eth.estimateGas(param);
      console.log(estimateGas);
      console.log(gasPrice);
      return new Promise((resolve, reject) => {
        console.log("param - ", param);
        try {
          web3.eth
            .sendTransaction(param)
            .on("transactionHash", async txHash => {
              console.log("transactionHash");
              console.log(txHash);
            })
            .on("receipt", async receipt => {
              console.log("receipt");
              resolve({ result: true, data: receipt });
            })
            .on("error", error => {
              console.log("error");
              console.log(error);
              if (error != null && error.code == 4001) {
                this.trading.status = "fail_cancel";
              }    
            });
          // console.log(result);
          // return {result: true, data: result};
        } catch (e) {
          // return {result: false, data: e};
          reject();
        }
      });
    },
    buy: async function(mode) {
      if (this.account == null) {
        this.$store.commit('openModal', 'wallet');
        return;
      }
      await refreshAccountBalance(this.$store);
      if (mode == 1) {
        this.arrangeBasicCart();
      } else {
        this.arrangeAdvancedCart();
      }
      this.computePrice();
      if (this.amount.total == 0 || this.amount.price == 0) {
        return alert(this.$t("alert_select_land"));
      }
      try {
        let ids = [];
        if (mode == 1) {
          var ret = await axios.post(`${config.api.nft_url}/presale/buy`, {
            carts: this.cart.byLevels
          });
          if (ret.data.result) {
            ids = ret.data.ids;
          }
          else {
            if (ret.data.err != null && ret.data.err.code == 'not_started') {
              return alert(this.$t("not_start_yet_presale"));
            }
          }
        } else {
          let ret =  await axios.post(`${config.api.nft_url}/presale/tryBuy`, {
          });
          if (!ret.data.result) {
            if (ret.data.err != null && ret.data.err.code == 'not_started') {
              return alert(this.$t("not_start_yet_presale"));
            }
            return;
          }

          for (let i = 0; i < this.cart.byLands.length; ++i) {
            ids.push(this.cart.byLands[i].landId);
          }
        }
        console.log(ids);
        this.landIds = ids;
        this.openPopup("buyResult");
        this.trading.status = "trading";
        this.trading.txHash = "";

        var txData = null;
        var txPrice = 0;
        if (this.selectedToken.token_symbol == "ETH") {
          if (mode == 1) {
            ga.gaEvent('event', 'buy', {
              'event_category': 'basic_eth',
              'event_label': JSON.stringify(this.amount)
            });
          }            
          else {
            ga.gaEvent('event', 'buy', {
              'event_category': 'advanced_eth',
              'event_label': JSON.stringify(this.amount)
            });
          }

          if (this.amount.price > this.account.balance) {
            ga.gaEvent('event', 'buyFail', {
                'event_label': 'insufficient_balance'
              });
            throw { code: "fail_buy_insufficient_balance" };
          }
          txData = contract.methods.buyLands(ids).encodeABI();
          txPrice = this.amount.price;

          this.openPopup("buyResult");
          this.trading.status = "trading";
          this.trading.txHash = "";
        } else {
          if (mode == 1) {
              ga.gaEvent('event', 'buy', {
                'event_category': 'basic_kyber',
                'event_label': JSON.stringify(this.amount)
              });
            }            
            else {
              ga.gaEvent('event', 'buy', {
                'event_category': 'advanced_kyber',
                'event_label': JSON.stringify(this.amount)
              });
            }

          const SRC_TOKEN_CONTRACT = new web3.eth.Contract(
            ERC20_ABI,
            this.selectedToken.token_address
          );
          console.log(
            this.selectedToken.token_address,
            web3.eth.currentProvider.selectedAddress,
            contract.options.address
          );
          var allowance = await SRC_TOKEN_CONTRACT.methods
            .allowance(
              web3.eth.currentProvider.selectedAddress,
              contract.options.address
            )
            .call();
          // contract.methods.
          console.log("allowance - ", allowance);
          if (
            this.amount.price / this.selectedToken.rate_eth_now >
            this.account.balance
          ) {
            ga.gaEvent('event', 'buyFail', {
                'event_label': 'insufficient_balance'
              });
            throw { code: "fail_buy_insufficient_balance" };
          }

          var amount = WEI(this.amount.price / this.selectedToken.rate_eth_now);
          console.log("amount - ", amount);
          if (allowance < amount) {
            this.openPopup("buyResult");
            this.trading.status = "trading_kyber";
            this.trading.txHash = "";
            let { result, data } = await this.sendTo(
              this.selectedToken.token_address,
              SRC_TOKEN_CONTRACT.methods
                .approve(contract.options.address, WEI(1000000000000))
                .encodeABI(),
              0
            ); //web3.eth.currentProvider.selectedAddress,
            this.trading.status = "trading";
            console.log(result);
          }
          else {
            this.openPopup("buyResult");
            this.trading.status = "trading";
            this.trading.txHash = "";
          }
          txData = contract.methods
            .buyLandsByToken(ids, this.selectedToken.token_address, amount)
            .encodeABI();
          txPrice = 0;
        }

        let { result, data } = await this.send(txData, txPrice);
        console.log("result - ", result);
        console.log("data - ", data);
        if (result == true) {
          await refreshAccountBalance(this.$store);
          this.clearAllCart();
          if (mode == 2) {
            setTimeout(() => {
              this.$store.commit("refreshZone", { refresh: true });
            }, 5 * 1000);
          }
          this.trading.status = "completed";
        } else {
          this.trading.status = "fail_duplicated";
        }
      } catch (e) {
        if (e != null && e.code != null) {
          if (isNaN(e.code)) {
            this.trading.status = e.code;
          }
          else {
            this.trading.status = "fail_abnormal";
          }          
        } else {
          this.trading.status = "fail_duplicated";
        }
      }
    },
    changeLandId: async function(landId) {
      if (landId != null) {
        landId = parseInt(landId);
        if (landId >= 100000 && landId <= 165535) {
          this.landUrl = `${config.web.url}/map/${landId}`;

          let currentLandId = landId;
          landId = landId % 100000;
          let landX = landId % 256;
          let landY = 255 - Math.floor(landId / 256);
          landX = Math.floor(landX / 32);
          landY = Math.floor(landY / 32);
          let zoneIdx = landY * 8 + landX;

          let zoneId = this.$store.state.map.zoneMap[zoneIdx];
          this.$store.commit("clickWorldMap", {
            key: zoneId
          });
          this.$store.commit("setSelectedLandId", currentLandId);
        }
      }
    },
    getHexColor: function(number) {
      return "#" + (number >>> 0).toString(16).slice(-6);
    },
    getLandInfo: function(landId) {
      console.log("getLandInfo - ", landId);
      return new Promise((resolve, reject) => {
        axios
          .get(`${config.api.game_url}/land/info?landId=${landId}`, {})
          .then(ret => {
            if (ret.data.result == true) {
              resolve(ret.data.land);
            } else {
              reject();
            }
          });
      });
    },
    getFieldObjects: function(landId) {
      console.log("getFieldObjects - ", landId);
      return new Promise((resolve, reject) => {
        axios
          .get(`${config.api.game_url}/field/fieldobjects?landId=${landId}`, {})
          .then(ret => {
            if (ret.data.result == true) {
              let objects = ret.data.objects;
              landId = landId % 100000;
              let landX = landId % 256;
              let landY = Math.floor(landId / 256);
              let x = landX * 8;
              let y = landY * 8;
              for (let i = 0; i < objects.length; ++i) {
                objects[i].x = (objects[i].loc[1] - x) * 37.5 - 10;
                objects[i].y = (7 - (objects[i].loc[2] - y)) * 37.5;
                if (
                  objects[i].code >= 20100101 &&
                  objects[i].code <= 20100104
                ) {
                  objects[i].display = objects[i].code - 20100100;
                } else if (
                  objects[i].code >= 20200101 &&
                  objects[i].code <= 20200103
                ) {
                  objects[i].display = objects[i].code - 20200100 + 4;
                } else if (objects[i].code == 20200201) {
                  objects[i].display = 8;
                }
              }
              resolve(objects);
            } else {
              reject();
            }
          });
      });
    }
  },
  computed: {
    currentLandId() {
      return this.$store.state.area.selectedLand;
    },
    currentZone() {
      return this.$store.state.map.currentZone;
    },
    renderGrid() {
      return !HIDE_GRID_WHEN_SCROLLING || !this.isScrolling;
    },
    account() {
      return this.$store.state.account.wallet;
    },
    selectedToken() {
      return this.$store.state.account.token;
    },
    selectedId() {
      let landId = this.$route.params.landId;
      if (landId == null) {
        return 0;
      }
      return parseInt(landId);
    }
  },
  filters: {
    comma(val) {
      if (val < 0) {
        val = 0;
      }
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  created: async function() {},
  mounted: async function() {
    let screenWidth = this.$vssWidth;
    let minimapSize = Math.floor(screenWidth * 0.96) - 12;
    let minimapTileSize = Math.floor(minimapSize / 8);
    minimapSize = minimapTileSize * 8;
    this.minimapSize = minimapSize;
    this.minimapTileSize = minimapTileSize;

    var curs = await fetch("https://api.kyber.network/change24h");
    var data = await curs.json();
    var list = [];
    var map = {};
    let pre = [null, null];
    for (var name in data) {
      var item = data[name];
      if (item.rate_eth_now == 0) {
        continue;
      }
      map[item.token_symbol] = item;
      list.push(item);
      if (item.token_symbol == 'ETH') {
        pre[0] = item;
      }
      else if (item.token_symbol == 'DAI') {
        pre[1] = item;
      }
    }
    list = pre.concat(list);
    this.tokenMap = map;
    this.tokens = list;

    this.$store.commit("setToken", this.tokenMap["ETH"]);

    await this.loadLandSaleInfo();
    this.timerId = setInterval(async () => {
      await this.loadLandSaleInfo();
    }, 10 * 1000);
  },
  beforeDestroy: function() {
    if (this.timerId != null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
    this.clearAllCart();
    this.$store.commit("clearSelectedLands");
  },
  watch: {
    landNum(val, oldVal) {
      for (let i = 0; i < this.landNum.length; ++i) {
        if (!isNumeric(this.landNum[i]) || this.landNum[i] == '') {
          this.landNum[i] = 0;
        }
        else {
          this.landNum[i] = parseInt(this.landNum[i]);
        }        
      }
      if (this.landNum[6] > 4) {
        this.landNum[6] = 4;
        alert(this.$t("alert_6lv_limit"));
      }
      for (let i = 0; i < this.products.length; ++i) {
        let level = this.products[i].level;
        let select = this.landNum[level];
        if (select > this.products[i].remain) {
          select = this.products[i].remain;
          this.landNum[level] = select;
        }
        this.$set(this.basic.selected, "level_" + level, select);
      }
      this.arrangeBasicCart();
    },
    "$store.state.map.selectedLands": function(val) {
      this.$set(this.cart, 'byLands', val);
      this.updateCart();
      if (this.cart.byLands.length > 0) {
        let lastLand = this.cart.byLands[this.cart.byLands.length - 1];
        for (let i = 0; i < this.cart.byLevels.length; ++i) {
          let cart = this.cart.byLevels[i];
          for (let j = 0; j < this.products.length; ++j) {
            let product = this.products[j];
            if (product.level == cart.level) {
              if (product.remain < cart.num) {
                this.$store.commit('clearSelectedLand', {landId: lastLand.landId});
                return alert(this.$t("alert_fail_insufficient_land"));
              }
              if( product.remain < cart.num) {
                this.$store.commit('clearSelectedLand', {landId: lastLand.landId});
                return alert(this.$t("alert_fail_maybe_insufficient_land"));
              }
            }
          }
          if (cart.level == 6 && cart.num > 4) {
            this.$store.commit('clearSelectedLand', {landId: lastLand.landId});
            return alert(this.$t("alert_6lv_limit"));            
          }
        }
      }

      console.log('cart - ', this.cart.byLands);
    },
    "$store.state.map.currentZone": function(val) {
      this.toggle(1);
    },
    "$route.params.landId": function(landId) {
      this.changeLandId(landId);
    },
    async currentZone(val, oldVal) {
      await this.loadLandSaleInfo(val);
    },
    async currentLandId(val) {
      const treeCodes = [501, 502, 503, 504, 505, 601, 602, 603];
      this.trees = [];
      for (let i = 0; i < 10; ++i) {
        this.trees.push({
          _id: i,
          code: treeCodes[Math.floor(Math.random() * treeCodes.length)],
          x: Math.floor(Math.random() * 8) * 40,
          y: Math.floor(Math.random() * 8) * 40
        });
      }
      this.landUrl = `${config.web.url}/map/${val[0]}`;
      this.landInfo = await this.getLandInfo(val[0]);
      if (this.landInfo.sale == null || this.landInfo.sale.price == null) {
        this.landInfo.sale = {
          status: 1,
          price: 0
        }
      }
      this.objects = await this.getFieldObjects(val[0]);
      this.selectedLandId = this.landInfo.landId;
    }
  },
  data: function() {
    return {
      landNum: [0,0,0,0,0,0,0],
      toggles: [true, false],
      viewport: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      },
      timerId: null,
      popups: {
        wallet: false,
        buyResult: false
      },
      tabs: [true, false],
      products: [],
      basic: {
        period: [],
        selected: {}
      },
      cart: {
        byLevels: [],
        byLands: []
      },
      landIds: [],
      remainLands: [],
      token: "ETH",
      tokens: [
        { name: "ETH", value: "eth" },
        { name: "KNC", value: "knc" }
      ],
      tokenMap: {},
      amount: {
        total: 0,
        price: 0
      },
      trading: {
        status: "none",
        txHash: ""
      },
      showGridChecked: true,
      visibleDevRank: "off",
      selectedLandId: 0,
      landInfo: {},
      objects: [],
      trees: [],
      landUrl: "",
      minimapSize: 0,
      mapSize: 0,
      minimapTileSize: 0,
      mapTileSize: 0,
      minimapScroll: [0, 0, 0, 0]
    };
  }
};
</script>
<style>
select {
  -webkit-appearance: none; /* 네이티브 외형 감추기 */
  -moz-appearance: none;
  appearance: none;
  border: none;
  outline: 0px;
}

/* IE 10, 11의 네이티브 화살표 숨기기 */
select::-ms-expand {
  display: none;
  border: none;
}
.map-title3 {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  color: #00ff00;
  width: 600px;
  height: 50px;
  text-align: left;
}
.map-title4 {
  position: absolute;
  top: 5px;
  left: 0%;
  transform: translateX(-50%);
  color: #00ff00;
  width: 500px;
  height: 50px;
  text-align: right;
}
.map-title-devrank {
  position: absolute;
  top: 80px;
  left: 255px;
  width: 640px;
  height: 50px;
  text-align: right;
}
.map-area2 {
  position: absolute;
  top: 160px;
  left: 50%;
  transform: translateX(-50%);
  width: 723.36px;
  height: 741.84px;
  background-image: url("/img/frame_zone.png");
  background-size: 100% 100%;
  overflow: none;
  z-index: 0;
}
.map-scroll-stage2 {
  position: absolute;
  top: 25.6px;
  left: 50%;
  transform: translateX(-50%);
  width: 704px;
  height: 704px;
  overflow: none;
}
.minimap-area2 {
  position: absolute;
  top: 182px;
  right: calc(50% + 380px);
  width: 306px;
  height: 306px;
  background-image: url("/img/frame_world.png");
  background-size: 100% 100%;
  overflow: none;
  z-index: 0;
}
.minimap-title2 {
  position: absolute;
  top: 120px;
  width: 306px;
  height: 50px;
  text-align: center;
}
.minimap-scroll-stage2 {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 300px;
  height: 300px;
  overflow: none;
}
.zoneinfo-area {
  position: absolute;
  top: 188px;
  left: calc(50% - 153px);
  width: 306px;
  height: 140px;
  background-image: url("/img/1st_sale/bg_zone_info.png");
  background-size: 100% 100%;
  overflow: none;
  z-index: 0;
}
.gamemap-area2 {
  z-index: 0;
  position: absolute;
  top: 577px;
  right: calc(50% + 380px);
  width: 306px;
  height: 327px;
  background-image: url("/img/frame_field.png");
  overflow: none;
}
.gamemap-title2 {
  position: absolute;
  top: 3px;
  width: 300px;
  height: 50px;
  text-align: center;
  color: white;
}
.gamemap-scroll-area2 {
  position: absolute;
  top: 25px;
  left: 4px;
  width: 300px;
  height: 300px;
  background-image: url("/img/map/map_01.png");
  overflow: none;
}
.land-info-title2 {
  position: absolute;
  top: 3px;
  width: 320px;
  height: 50px;
  text-align: center;
  color: white;
}
.land-info-area2 {
  z-index: 0;
  position: absolute;
  top: 155px;
  left: calc(50% + 380px);
  width: 328px;
  height: 346px;
  overflow: none;
  background-image: url("/img/1st_sale/frame_field_info_3.png");
  padding: 10px;
}
.cart-area2 {
  z-index: 0;
  position: absolute;
  left: 0;
  width: 100%;
  height: 410px;
  overflow: none;
  background-image: url("/img/1st_sale/bg_sale_3.png");
  background-size: 100% 100%;
}
.scrollbox {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.scrollbox::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.map-title {
  color: #00ff00;
  width: 600px;
  height: 25px;
  text-align: left;
  padding: 10px 70px;
}
.map-title-devrank {
  position: absolute;
  top: 80px;
  left: 255px;
  width: 800px;
  height: 50px;
  text-align: right;
}
.map-area {
  width: 704px;
  height: 704px;
  margin: 0px auto;
}
.map-scroll-stage {
  width: 704px;
  height: 704px;
}
.minimap-area3 {
  width: 100vw;
  height: 100vw;
  overflow: none;
  margin: 0px auto;
  background-image: url("/img/frame_world.png");
  background-size: 100% 100%;
}
.minimap-title3 {
  position: absolute;
  top: 120px;
  width: 328px;
  height: 50px;
  text-align: center;
}
.minimap-scroll-stage3 {
  margin: auto;
  width: 100%;
  height: 100%;
  padding: 6px;
  overflow: none;
}
input,
textarea:focus {
  outline: none;
}
</style>
